import { useState } from 'react';
import api from '../lib/api';

export default function AdmCanonicalReview({ packageSha }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [flags, setFlags] = useState({});
  const [note, setNote] = useState('');
  const [receipt, setReceipt] = useState(null);
  const [busy, setBusy] = useState(false);
  async function load() {
    setBusy(true); setError('');
    try { setData((await api.get('/admin/adm-revision/canonical-evidence')).data); }
    catch { setError('Impossibile caricare le evidenze canoniche. Nessuna decisione registrata.'); }
    finally { setBusy(false); }
  }
  async function record() {
    setBusy(true); setError('');
    try {
      setReceipt((await api.post('/admin/adm-revision/program-review', {
        package_sha256: packageSha, expected_live_sha256: data.live.live_sha256,
        expected_program_sha256: data.program.program_sha256,
        declared_program_reviewed: !!flags.program,
        limits_and_no_future_bando_reviewed: !!flags.limits, note,
      })).data);
    } catch { setError('Programma non registrato: verificare i campi e ricaricare in caso di variazioni live.'); }
    finally { setBusy(false); }
  }
  return <section className="surface p-4 space-y-3" aria-label="Gate canonici ADM">
    <h2 className="font-semibold">Programma generale e gate canonici</h2>
    <p>Il prodotto non dipende da un futuro bando. Il programma editoriale dichiarato ha una propria revisione, distinta dall’approvazione delle fonti e dalla pubblicazione.</p>
    <button className="border rounded px-4 py-2" disabled={busy} onClick={load}>Carica evidenze e associazioni canoniche</button>
    {error && <p role="alert">{error}</p>}
    {data && <>
      <p>Controlli strutturali: {data.technical_blockers.length ? data.technical_blockers.join(', ') : 'SUPERATI'}.</p>
      <p>{data.counts.sections} sezioni / {data.counts.maps} mappe / {data.counts.quizzes} quiz. Le associazioni sono proposte, non decisioni umane.</p>
      <details><summary>Programma dichiarato, limiti e associazioni esatte</summary>
        <p>{data.program.disclaimer}</p>
        {data.program.requirements.map(r => <div key={r.requirement_id}><h3 className="font-semibold">{r.requirement_id}</h3><p>{r.quote}</p>
          <ul>{Object.entries(data.associations).filter(([, ids]) => ids.includes(r.requirement_id)).map(([key]) => <li key={key} className="text-xs break-all">{key}</li>)}</ul></div>)}
      </details>
      <details><summary>Evidenze individuali delle 11 varianti da verificare</summary>
        {data.rights_evidence.map(r => <details key={r.id} className="border-t py-2"><summary>{r.title}</summary><p>{r.instruction}</p><p className="text-xs break-all">{r.id} · {r.artifact_sha256}</p>
          <pre className="text-xs whitespace-pre-wrap break-all max-h-96 overflow-auto">{JSON.stringify({ contenuto: r.artifact, provenienza: r.source_evidence }, null, 2)}</pre></details>)}
      </details>
      <details><summary>Collegamenti e riferimenti nel formato della piattaforma</summary>
        <p>Non importati, non verificati editorialmente e senza autorizzazioni di riuso implicite.</p>
        <pre className="text-xs whitespace-pre-wrap break-all max-h-96 overflow-auto">{JSON.stringify({ links: data.proposed_content_links, references: data.proposed_source_references }, null, 2)}</pre>
      </details>
      <label className="flex gap-2"><input type="checkbox" checked={!!flags.program} onChange={e => setFlags({ ...flags, program: e.target.checked })} />Ho esaminato e approvo il programma editoriale dichiarato, non un programma d’esame futuro.</label>
      <label className="flex gap-2"><input type="checkbox" checked={!!flags.limits} onChange={e => setFlags({ ...flags, limits: e.target.checked })} />Ho verificato i limiti di copertura e la distinzione dal bando storico.</label>
      <label className="block">Motivazione sul programma (minimo 40 caratteri)<textarea className="block w-full border rounded p-2" value={note} onChange={e => setNote(e.target.value)} maxLength={8000} /></label>
      <button className="border rounded px-4 py-2 disabled:opacity-50" onClick={record} disabled={busy || !!receipt || !data.live.compatible || data.program.package_sha256 !== packageSha || !!data.technical_blockers.length || !flags.program || !flags.limits || note.trim().length < 40}>Registra decisione umana sul programma</button>
      {receipt && <p role="status">Decisione registrata: {receipt.review_id}. {receipt.note}</p>}
      <p>Nessuna modifica al corso pubblico. Restano separati la revisione puntuale dello scope, i diritti delle fonti e l’approvazione dei contenuti.</p>
    </>}
  </section>;
}
